import styled from 'styled-components';
import PrimaryButton from '@carvana/showroom-forms/Button/Primary';
import SecondaryButton from '@carvana/showroom-forms/Button/Secondary';
import Checkbox from '@carvana/showroom-forms/Checkbox';

const AutopayEnrollmentWrapper = styled.div`
  align-content: flex-start;
  border-radius: ${(props) => props.theme.border.radius};
  background-color: ${(props) => props.theme.color.neutral.v100};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  font-family: 'Brandon Text';
  justify-content: flex-start;
  width: 90%;
  height: 100%;
  margin: 0;

  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    min-width: 325px;
    justify-content: flex-start;
  }

  @media (max-width: ${(props) => props.theme.breakpoint.sm}px) {
    min-height: 410px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    min-height: auto;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.xl}px) {
    max-width: 1060px;
    min-height: 320px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.xxl}px) {
    margin: 0;
  }
`;

const AutopayEnrollmentFieldset = styled.fieldset`
  border: none;
  display: flex;
  flex-direction: row;
  margin-bottom: 30px;
  padding: 0;
  justify-content: space-between;
`;

const AutopayConsentRow = styled.div`
  color: #6d7184;
  border: none;
  display: flex;
  flex-direction: row;
  margin: 20px 0 20px 15px;
  font-size: 16px;
  font-weight: 400;
`;

const AutopayButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 100%;
`;

const AutopayEnrollButton = styled(PrimaryButton)`
  padding: 0;
  width: 100%;
  min-width: 200px;
  min-height: 56px;
  font-size: 14px;
  margin: 10px 0 0 15px;

  @media (min-width: 376px) {
    max-width: 250px;
    text-align: center;
    margin: 10px 14px 0 15px;
  }
`;

const AutopayEnrollWithCopyButton = styled(SecondaryButton)`
  padding: 0;
  width: 100%;
  min-width: 200px;
  min-height: 56px;
  font-size: 14px;
  margin: 10px 0 0 15px;

  @media (min-width: 376px) {
    max-width: 250px;
    text-align: center;
    margin: 10px 14px 0 15px;
  }
`;

const AutopayEnrollmentCheckbox = styled(Checkbox)`
  margin-top: 4px;
  margin-bottom: 10%;
  align-items: flex-start;
`;

const AutopayError = styled.div`
  color: red;
  margin-bottom: 15px;
  font-weight: bold;
`;

export {
  AutopayButtonRow,
  AutopayEnrollmentWrapper,
  AutopayEnrollButton,
  AutopayEnrollWithCopyButton,
  AutopayEnrollmentCheckbox,
  AutopayError,
  AutopayEnrollmentFieldset,
  AutopayConsentRow,
};
